import { FiltrarProdutosService } from "../../../../core/services/behavior/filtrar-produtos.service";
import { Component, ElementRef, HostListener, Input, OnChanges, OnInit, QueryList, SimpleChanges, ViewChildren } from "@angular/core";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { map } from "rxjs";
import { ProdutoService } from "src/app/core/services/http/produto.service";
import { PlataformaProdutoResponse } from "src/app/shared/models/plataforma-produto-response";
import { AdicionalProdutoRequest, AdicionalProdutoViewModel, IngredienteProdutoRequest, IngredienteProdutoViewModel, ProdutoRequest, ProdutoResponse } from "src/app/shared/models/produto.model";
import { ProdutoCadastradoResumoModel } from "src/app/shared/models/ProdutoCadastradoResumoModel";
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ViewChild } from '@angular/core';
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { CadastroPerguntasService } from "src/app/core/services/behavior/cadastro-perguntas.service";
import { CastModelUtils } from "src/app/shared/utils/CastModelUtils";
import { ProdutoIntegracaoService } from "src/app/core/services/behavior/produto-integracao.service";
import { ModalController } from "@ionic/angular";
import { GrupoComponent } from "../../grupo/grupo.component";
import { SubGrupoComponent } from "../../sub-grupo/sub-grupo.component";
import { ToastService } from "src/app/core/services/behavior/toast.service";
import { ProdutoCategoriaModel, ProdutoFamiliaModel } from "src/app/shared/models/produto-familia.model";
import { StorageService } from "src/app/core/services/behavior/storage.service";
import { AdicionaisProdutoComponent } from "../../adicionais-produto/adicionais-produto.component";

@Component({
    selector: "app-aba-geral-cadastro-produtos",
    templateUrl: "./aba-geral-cadastro-produtos.component.html",
    styleUrls: ["./aba-geral-cadastro-produtos.component.scss"],
})
export class AbaGeralCadastroProdutosComponent implements OnInit, OnChanges {
    @ViewChildren("checks") private _checks: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChild('paginador', { read: ElementRef }) paginadorElement!: ElementRef;
    @ViewChild(AdicionaisProdutoComponent) adicionaisProdutoComponent!: AdicionaisProdutoComponent;

    @Input() alturaLivre: number = 0;

    private _plataformasParaAdicionar: any[] = [];
    private _plataformasParaRemover: PlataformaProdutoResponse[] = [];
    private _produtoEmEdicao: ProdutoCadastradoResumoModel = null; // TODO: Fazer via service, assim que finalizar o backend.
    private _listaProduto: ProdutoResponse[] = [];
    private listapordutosPizzaLasanha: ProdutoResponse[] = [];
    produtoAtual!: ProdutoResponse | null;
    public paginaAtual: number = 1;
    public produtosPorPagina: number = 13;
    public totalPaginas: number = 1;
    public produtoSelecionado: ProdutoResponse = null;

    public separatorKeysCodes: number[] = [ENTER, COMMA];
    public ingredientesFiltrados: Observable<IngredienteProdutoViewModel[]>;
    public ingredientesAdicionados: IngredienteProdutoViewModel[] = [];
    public novaListaIngredientes: IngredienteProdutoViewModel[] = [];
    public listaIngredientes: IngredienteProdutoViewModel[] = [];
    public listaIngredinetesMap = new Map<number, IngredienteProdutoViewModel>();

    public adicionaisFiltrados: Observable<AdicionalProdutoViewModel[]>;
    public adicionaisAdicionados: AdicionalProdutoViewModel[] = [];
    public novaListaAdicionais: AdicionalProdutoViewModel[] = [];
    public listaAdicionais: AdicionalProdutoViewModel[] = [];
    public listaAdicionaisMap = new Map<number, AdicionalProdutoViewModel>();
    public emEdicao: boolean = false;
    public precoAdicional: string = "";
    public codigoNaoEncontrado: boolean = false;
    public adicionandoAdicional: boolean = false;

    public cadastroPerguntas: boolean = false;

    @ViewChild(MatAutocompleteTrigger) autocompleteTrigger!: MatAutocompleteTrigger;

    public cadastroProdutoForm = this._formBuilder.group({
        codigoBarrasCtrl: new FormControl<number>(null),
        nomeCtrl: new FormControl<string>("", [Validators.required]),
        descricaoCtrl: new FormControl<string>(""),
        grupoIdCtrl: new FormControl<number>(null, [Validators.required]),
        subGrupoIdCtrl: new FormControl<number>(null, [Validators.required]),
        adicionalCtrl: new FormControl<string>(""),
        ingredienteCtrl: new FormControl<string>(""),
        valorVendaCtrl: new FormControl<number>(null, [Validators.required]),
    });
    public grupos$ = this._produtoService
        .getProdutosFamilia()
        .pipe(map((l) => (l.success ? l.data : [])));
    public grupos: ProdutoFamiliaModel[] = [];
    public imagemSelecionada: string | ArrayBuffer;
    public plataformas = null;
    public produtosFiltrados: ProdutoResponse[] = [];
    public subGrupos$ = this._produtoService
        .getSubGrupos()
        .pipe(map((l) => (l.success ? l.data : [])));
    public subGrupos: ProdutoCategoriaModel[] = [];

    constructor(
        private _formBuilder: FormBuilder,
        private _filtrarProdutosService: FiltrarProdutosService,
        private _produtoService: ProdutoService,
        private cadastroPerguntasService: CadastroPerguntasService,
        private produtoInregracaoService: ProdutoIntegracaoService,
        private modalCtrl: ModalController,
        private toastService: ToastService,
        private storageService: StorageService,
    ) {
        this.ingredientesFiltrados = this.cadastroProdutoForm.get('ingredienteCtrl').valueChanges.pipe(
            startWith(null),
            map((ingrediente: string | null) => (ingrediente ? this.filtrarIngredientes(ingrediente) : this.listaIngredientes.slice())),
        );

        this.adicionaisFiltrados = this.cadastroProdutoForm.get('adicionalCtrl').valueChanges.pipe(
            startWith(null),
            map((adicional: string | null) => (adicional ? this.filtrarAdicionais(adicional) : this.listaAdicionais.slice())),
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        const tamanhoItem: number = 50;
        const alturaPaginador: number = this.paginadorElement.nativeElement.offsetHeight;

        if (changes['alturaLivre']) {
            this.produtosPorPagina = Math.floor((this.alturaLivre - alturaPaginador) / tamanhoItem);
        }
    }

   enterComoTab(event): void {

  const elemento = event.target as HTMLElement;

  // Se for botão, deixa o comportamento normal acontecer
  if (elemento instanceof HTMLButtonElement) {
    return;
  }

  // Só transforma Enter em Tab para input e select
  if (
    elemento instanceof HTMLInputElement ||
    elemento instanceof HTMLSelectElement
  ) {
    event.preventDefault();

    const form = elemento.closest('form');

    const campos = Array.from(
      form?.querySelectorAll(
        'input, select, textarea, button'
      ) ?? []
    ) as HTMLElement[];

    const indice = campos.indexOf(elemento);

    if (indice >= 0 && indice < campos.length - 1) {
      campos[indice + 1].focus();
    }
  }
}

    // @HostListener('window:resize', ['$event'])
    // getScreenSize() { }

    public focoInputIngrediente() {
        setTimeout(() => this.autocompleteTrigger.closePanel(), 100);
    }

    public addIngrediente(event: any): void {
        const value = this.cadastroProdutoForm.get('ingredienteCtrl')?.value?.trim();
        if (!value || value.length === 0) return;

        const ingredienteRequest = new IngredienteProdutoRequest();
        ingredienteRequest.nome = value;
        ingredienteRequest.codigoProduto = this.produtoSelecionado.codigo;

        this._produtoService.incluirIngrediente(ingredienteRequest).subscribe((res) => {
            if (res.success) {
                const ingredienteEncontrado = this.listaIngredientes.find(ingrediente => ingrediente.nome.toLowerCase() === value.toLowerCase());
                const ingredienteExistente = this.ingredientesAdicionados.some(i => i.nome === ingredienteEncontrado?.nome);

                if (value && ingredienteEncontrado && !ingredienteExistente) {
                    this.ingredientesAdicionados.push(ingredienteEncontrado);
                }

                if (!ingredienteEncontrado && !ingredienteExistente) {
                    const novoIngrediente: IngredienteProdutoViewModel = {
                        nome: this.cadastroProdutoForm.get('ingredienteCtrl')?.value,
                        codigo: this.produtoSelecionado.codigo,
                    };

                    this.ingredientesAdicionados.push(novoIngrediente);
                    this.novaListaIngredientes.push(novoIngrediente);
                }

                this.cadastroProdutoForm.get('ingredienteCtrl').setValue(null);
            }
        })
    }

    public alterarPrecoAdiconal(event: any) {
        const preco = event.target.value;

        if (preco) {
            this.precoAdicional = preco;
        }
    }

    public addAdicional(event: any): void {
        const value = this.cadastroProdutoForm.get('adicionalCtrl')?.value?.trim();
        if (!value || value.length === 0) return;

        const precoAdicionalNumber: number = Number(this.precoAdicional.replace(/\./g, '').replace(',', '.'));

        const adicionalRequest = new AdicionalProdutoRequest();

        adicionalRequest.nome = value;
        adicionalRequest.codigoProduto = this.produtoSelecionado.codigo;
        adicionalRequest.precoAdicional = precoAdicionalNumber;

        const erros = this.validarAdiconal(adicionalRequest);

        if (erros.length > 0) {
            this.toastService.show(erros.join(",\n"), "error");
            return;
        }

        this.adicionandoAdicional = true;

        this._produtoService.incluirAdicional(adicionalRequest).subscribe({
            next: (res) => {
                this.adicionandoAdicional = false;
                if (res.success) {
                    const adicionalEncontrado = this.listaAdicionais.find(adicional => adicional.nome.toLowerCase() === value.toLowerCase());
                    const adicionalExistente = this.adicionaisAdicionados.some(i => i.nome === adicionalEncontrado?.nome);

                    if (value && adicionalEncontrado && !adicionalExistente) {
                        this.adicionaisAdicionados.push(adicionalEncontrado);
                    }

                    if (!adicionalEncontrado && !adicionalExistente) {
                        const novoAdicional: AdicionalProdutoViewModel = {
                            nome: this.cadastroProdutoForm.get('adicionalCtrl')?.value,
                            codigo: this.produtoSelecionado?.codigo ?? 0,
                            precoAdicional: precoAdicionalNumber,
                        };

                        this.adicionaisAdicionados.push(novoAdicional);
                        this.novaListaAdicionais.push(novoAdicional);
                    }

                    this.cadastroProdutoForm.get('adicionalCtrl').setValue(null);
                    this.precoAdicional = "";
                    if (this.adicionaisProdutoComponent) {
                        this.adicionaisProdutoComponent.limparPrecoInput();
                    }
                }
            },
            error: () => this.adicionandoAdicional = false
        });

    }

    public removerIngrediente(ingrediente: IngredienteProdutoViewModel): void {
        const ingredienteRequest = new IngredienteProdutoRequest();
        ingredienteRequest.nome = ingrediente.nome;
        ingredienteRequest.codigoProduto = this.produtoSelecionado.codigo;

        this._produtoService.removerIngredineteProduto(ingredienteRequest).subscribe((res) => {
            if (res.success) {
                const index = this.ingredientesAdicionados.indexOf(ingrediente);
                if (index >= 0) this.ingredientesAdicionados.splice(index, 1);
            }
        });
    }

    public ativarDesativarProduto(produto: ProdutoResponse) {
        produto.ativo = !produto.ativo;

        this._produtoService.ativarDesativarProduto(produto).subscribe((res) => {
            this.produtoInregracaoService.alterarStatus(produto.codigo, produto.ativo);
        });
    }

    public removerAdicional(adicional: AdicionalProdutoViewModel): void {
        const adicionalRequest = new AdicionalProdutoRequest();
        adicionalRequest.nome = adicional.nome;
        adicionalRequest.codigoProduto = this.produtoSelecionado.codigo;

        this._produtoService.removerAdicionalProduto(adicionalRequest).subscribe((res) => {
            if (res.success) {
                const index = this.adicionaisAdicionados.indexOf(adicional);
                if (index >= 0) this.adicionaisAdicionados.splice(index, 1);
            }
        })
    }

    public selectedIngrediente(event: MatAutocompleteSelectedEvent): void {
        const ingrediente = this.listaIngredientes.find(i => i.nome === event.option.value);
        const ingredienteExistente = this.ingredientesAdicionados.some(i => i.nome === ingrediente?.nome);
        this.cadastroProdutoForm.get('ingredienteCtrl').setValue(null);

        if (ingrediente && !ingredienteExistente) {
            const ingredienteRequest = new IngredienteProdutoRequest();
            ingredienteRequest.nome = ingrediente.nome;
            ingredienteRequest.codigoProduto = this.produtoSelecionado.codigo;

            this._produtoService.incluirIngrediente(ingredienteRequest).subscribe((res) => {
                if (res.success) {
                    this.ingredientesAdicionados.push(ingrediente);
                }
            });
        }
    }

    public selectedAdicional(event: MatAutocompleteSelectedEvent): void {
        const adicional = this.listaAdicionais.find(i => i.nome === event.option.value);
        const adicionalExistente = this.adicionaisAdicionados.some(i => i.nome === adicional?.nome);
        this.cadastroProdutoForm.get('adicionalCtrl').setValue(null);

        if (adicional && !adicionalExistente) {
            const adicionalRequest = new AdicionalProdutoRequest();

            adicionalRequest.nome = adicional.nome;
            adicionalRequest.codigoProduto = this.produtoSelecionado.codigo;
            adicionalRequest.precoAdicional = this.produtoSelecionado.venda;

            this._produtoService.incluirAdicional(adicionalRequest).subscribe((res) => {
                if (res.success) {
                    this.adicionaisAdicionados.push(adicional);
                }
            });
        }
    }

    private filtrarIngredientes(value: string): IngredienteProdutoViewModel[] {
        return this.listaIngredientes.filter(ingrediente => ingrediente.nome.toLowerCase().includes(value.toLowerCase()));
    }

    private filtrarAdicionais(value: string): AdicionalProdutoViewModel[] {
        return this.listaAdicionais.filter(adicional => adicional.nome.toLowerCase().includes(value.toLowerCase()));
    }

    public abrirCadastroPerguntas(ativo: boolean) {
        // this.router.navigate(['/perguntas', this.produtoSelecionado.codigo]);
        this.cadastroPerguntas = ativo;

        if (ativo) {
            this.cadastroPerguntasService.nomeProduto.next(this.produtoSelecionado.nome);
            this.cadastroPerguntasService.codigoProduto.next(this.produtoSelecionado.codigo);
        } else {
            this.cadastroPerguntasService.nomeProduto.next(null);
        }
    }

    public get desabilitarPrecoAdicional(): boolean {
        const value = this.cadastroProdutoForm.get('adicionalCtrl')?.value;
        if (!value) return false;
        const existsInAdicionais = this.listaAdicionais.some(a => a.nome.toLowerCase() === value.toLowerCase());
        const existsInProdutos = this._listaProduto.some(p => p.nome.toLowerCase() === value.toLowerCase());
        return existsInAdicionais || existsInProdutos;
    }

    public get getExibirBotaoCancelar() {
        const retorno = (
            this.cadastroProdutoForm.dirty ||
            this.imagemSelecionada ||
            this._plataformasParaAdicionar.length > 0
        );

        if (retorno) {
            // this.cadastroProdutoForm.patchValue({
            //     grupoIdCtrl: 1,
            //     subGrupoIdCtrl: 1,
            // });
        }

        return retorno;
    }

    private get _getCodigoBarrasCtrl() {
        return this.cadastroProdutoForm.get("codigoBarrasCtrl");
    }

    private get _getDescricaoCtrl() {
        return this.cadastroProdutoForm.get("descricaoCtrl");
    }

    private get _getGrupoIdCtrl() {
        return this.cadastroProdutoForm.get("grupoIdCtrl");
    }

    private get _getNomeCtrl() {
        return this.cadastroProdutoForm.get("nomeCtrl");
    }

    private get _getSubGrupoIdCtrl() {
        return this.cadastroProdutoForm.get("subGrupoIdCtrl");
    }

    private get _getValorVendaCtrl() {
        return this.cadastroProdutoForm.get("valorVendaCtrl");
    }

    public alterarProdutoOnClick(produto: ProdutoResponse) {
        setTimeout(() => {
            const espacamentos = document.querySelectorAll('.mat-mdc-form-field-subscript-wrapper');

            espacamentos.forEach((espacamento) => {
                espacamento.remove();
            });

        });

        this.produtoSelecionado = produto;

        this.ingredientesAdicionados = [];
        this.adicionaisAdicionados = [];

        this.produtoSelecionado.composicao.forEach((composicao) => {
            const ingredienteEncontado = this.listaIngredinetesMap.get(composicao.codigoMatPrima);
            const adicionalEncontrado = this.listaAdicionaisMap.get(composicao.codigoMatPrima);

            if (ingredienteEncontado) this.ingredientesAdicionados.push(ingredienteEncontado);
            if (adicionalEncontrado) this.adicionaisAdicionados.push(adicionalEncontrado);
        });

        this._getCodigoBarrasCtrl.setValue(produto.codBarra);
        this._getNomeCtrl.setValue(produto.nome);
        this._getGrupoIdCtrl.setValue(produto.codFamilia);
        this._getSubGrupoIdCtrl.setValue(produto.codCategoria);
        // this._getEstoqueCtrl.setValue(produto.qtd);
        this._getValorVendaCtrl.setValue(produto.venda);
        // this._getDescricaoCtrl.setValue(produto.aplicacao);

        // produto.plataformasDisponiveis.forEach((plataforma) =>
        //     this._marcarComoCheckedCasoExista(plataforma.codigoPlataforma)
        // );

        //this._produtoEmEdicao = produto;
        // this._produtoEmEdicao = produto;

        this.emEdicao = true;
    }

    /**
     * @description Serve para cancelar a ação atual (adicionar ou atualizar produtos).
     */
    public cancelarAcaoOnClick(): void {
        this.cadastroProdutoForm.reset();

        this._desmarcarTodosChecks();

        this.imagemSelecionada = null;
        this._produtoEmEdicao = null;
        this.produtoSelecionado = null;
        this.emEdicao = false;
        this.codigoNaoEncontrado = false;
    }

    gravarOnSubmit() {
        debugger
        if (this.cadastroProdutoForm.valid) {
            const produtoFormValue = this.cadastroProdutoForm.value;

            const IngredienteProdutoRequest = this.ingredientesAdicionados.map(ingrediente => {
                return {
                    nome: ingrediente.nome,
                    codigoProduto: 0
                };
            });

            const AdicionalProdutoRequest = this.adicionaisAdicionados.map(adicional => {
                return {
                    nome: adicional.nome,
                    codigoProduto: 0,
                    precoAdicional: adicional.precoAdicional
                };
            });

            let codigoProduto = 0;

            if (!!this.produtoAtual && this.produtoAtual !== null) {
                codigoProduto = this.produtoAtual.codigo;
            }

            const novoProduto: ProdutoRequest = {
                codigo: codigoProduto,
                codBarra: produtoFormValue.codigoBarrasCtrl,
                nome: produtoFormValue.nomeCtrl,
                codFamilia: produtoFormValue.grupoIdCtrl,
                valorVenda: produtoFormValue.valorVendaCtrl,
                aplicacao: produtoFormValue.descricaoCtrl,
                codCategoria: produtoFormValue.subGrupoIdCtrl,
                codTipo: 1,
                utilizaBalanca: false,
                unMed: 'UN',
                codUsuario: 1,
                ingredientes: IngredienteProdutoRequest,
                adicionais: AdicionalProdutoRequest,
            };

            const erros = this.validarNovoProduto(novoProduto);

            if (erros.length > 0) {
                this.toastService.show(erros.join(",\n"), "error");
                return;
            }

            this._produtoService.AddOrUpdate(novoProduto).subscribe({
                next: async (response) => {
                    if (!response.success) {
                        return;
                    }

                    const produtoResponse: ProdutoResponse = CastModelUtils.ClonarObjetoComPropriedadesIguais(response.data, new ProdutoResponse());
                    produtoResponse.venda = novoProduto.valorVenda;
                    produtoResponse.ativo = true;

                    const produtos = await this.storageService.get('produtos');

                    if (!!produtos) {
                        const produtoEncontrado = produtos.find((p: ProdutoResponse) => p.codigo === produtoResponse.codigo);

                        if (produtoEncontrado) {
                            produtoEncontrado.nome = produtoResponse.nome;
                            produtoEncontrado.codBarra = produtoResponse.codBarra;
                            produtoEncontrado.codCategoria = produtoResponse.codCategoria;
                            produtoEncontrado.codFamilia = produtoResponse.codFamilia;
                            produtoEncontrado.valorVenda = produtoResponse.venda;
                        }

                        await this.storageService.set('produtos', produtos);
                    }

                    this.alterarOuAdicionarItemListaProduto(produtoResponse);
                    this.cancelarAcaoOnClick();
                },
                error: (error) => {
                    console.error("Erro ao salvar produto:", error);
                },
            });
        } else {
            console.error("Formulário inválido");
            this.toastService.show("Erro ao validar produto, verifique todos os campos antes de enviar.", "error");
        }
    }

    public alterarOuAdicionarItemListaProduto(produtoAlterado: ProdutoResponse) {
        const index = this._listaProduto.findIndex(p => p.codigo === produtoAlterado.codigo);

        if (index >= 0) {
            const itemEncontrado = this._listaProduto[index];

            itemEncontrado.nome = produtoAlterado.nome;
            itemEncontrado.codBarra = produtoAlterado.codBarra;
            itemEncontrado.codCategoria = produtoAlterado.codCategoria;
            itemEncontrado.codFamilia = produtoAlterado.codFamilia;
            itemEncontrado.venda = produtoAlterado.venda;

            this._filtrarProdutos('');
        } else {
            this._listaProduto.unshift(produtoAlterado);
            this._filtrarProdutos('');
        }
    }

    public ngOnInit() {
        this.carregarProdutos();
        this.carregarGrupos();
        this.carregarSubGrupos();

        this._filtrarProdutosService.filtro$.subscribe((filtro) => this._filtrarProdutos(filtro));

        this.produtosFiltrados = [...this._listaProduto];
        this.calcularTotalPaginas();
    }

    public async abrirGrupo() {
        const modal = await this.modalCtrl.create({
            component: GrupoComponent
        });

        await modal.present();

        await modal.onDidDismiss();
        this.atualizarGrupo();
    }

    public async abrirSubGrupo() {
        const modal = await this.modalCtrl.create({
            component: SubGrupoComponent
        });

        await modal.present();

        await modal.onDidDismiss();
        this.atualizerSubGrupo();
    }

    public atualizarGrupo() {
        this.grupos$ = this._produtoService.getProdutosFamilia().pipe(map((l) => (l.success ? l.data : [])));
        this.carregarGrupos();
    }

    public atualizerSubGrupo() {
        this.subGrupos$ = this._produtoService.getSubGrupos().pipe(map((l) => (l.success ? l.data : [])));
        this.carregarSubGrupos();
    }

    public removerProdutoOnClick(produto: ProdutoResponse) { }

    public async selecionouImagemOnChange(event: any) {
        const file = event.target.files[0];

        if (file) {
            this.imagemSelecionada = await this._readFileAsDataURL(file);
        }
    }

    private carregarGrupos() {
        this.grupos$.subscribe((res) => {
            this.grupos = res;
        });
    }

    private carregarSubGrupos() {
        this.subGrupos$.subscribe((res) => {
            this.subGrupos = res;
        });
    }

    public selecionouPlataformaOnChange(
        event: any,
        plataformaSelecionada: any
    ) {
        const checked = event.target.checked;

        const plataformaProduto = (
            this._produtoEmEdicao?.plataformasDisponiveis ?? []
        ).find((l) => l.codigoPlataforma === plataformaSelecionada.codigo);

        if (checked) {
            const indexRemover =
                this._plataformasParaRemover.indexOf(plataformaProduto);

            if (!plataformaProduto) {
                this._plataformasParaAdicionar.push(plataformaSelecionada);
            }

            if (indexRemover >= 0) {
                this._plataformasParaRemover.splice(indexRemover, 1);
            }
        } else {
            const indexAdicionar = this._plataformasParaAdicionar.indexOf(
                plataformaSelecionada
            );

            if (plataformaProduto) {
                this._plataformasParaRemover.push(plataformaProduto);
            }

            if (indexAdicionar >= 0) {
                this._plataformasParaAdicionar.splice(indexAdicionar, 1);
            }
        }
    }

    calcularTotalPaginas() {
        this.totalPaginas = Math.ceil(this.produtosFiltrados.length / this.produtosPorPagina);
    }

    private _filtrarProdutos(filtro: string) {
        if (!filtro) {
            this.produtosFiltrados = [...this._listaProduto];
        } else {
            filtro = filtro.toLowerCase();
            this.produtosFiltrados = this._listaProduto.filter((produto) => {
                const values = Object.values(produto).filter(
                    (l) => typeof l === 'number' || typeof l === 'string'
                );
                return values.some((val) =>
                    val.toString().toLowerCase().includes(filtro)
                );
            });
        }
        this.paginaAtual = 1;
        this.calcularTotalPaginas();
    }

    getProdutosPaginados(): ProdutoResponse[] {
        const inicio = (this.paginaAtual - 1) * this.produtosPorPagina;
        const fim = inicio + this.produtosPorPagina;
        return this.produtosFiltrados.slice(inicio, fim);
    }

    paginaAnterior() {
        if (this.paginaAtual > 1) {
            this.paginaAtual--;
        }
    }

    proximaPagina() {
        if (this.paginaAtual < this.totalPaginas) {
            this.paginaAtual++;
        }
    }

    public filtrarProdutosOnInput(value: string) {
        this._filtrarProdutosService.filtro$.next(value);
    }

    // private _marcarComoCheckedCasoExista(codigoPlataforma: number) {
    //     const check = this._obterCheckPorCodigoPlataforma(codigoPlataforma);

    //     if (check) {
    //         check.checked = true;
    //     }
    // }

    private _desmarcarTodosChecks() {
        const elementRefs = this._checks.toArray();
        const nativeElements = elementRefs.flatMap((l) => l.nativeElement);

        nativeElements.forEach((element) => (element.checked = false));
    }

    private _obterCheckPorCodigoPlataforma(
        codigoPlataforma: number
    ): HTMLInputElement {
        const elementRefs = this._checks.toArray();
        const nativeElements = elementRefs.flatMap((l) => l.nativeElement);

        return nativeElements.find(
            (l) =>
                l.attributes["data-plataforma-id"].value === codigoPlataforma.toString()
        );
    }

    private _readFileAsDataURL(file: File): Promise<string | ArrayBuffer> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = () => {
                resolve(reader.result);
            };

            reader.onerror = () => {
                reject(reader.error);
            };

            reader.readAsDataURL(file);
        });
    }

    // private carregarGrupos() {
    //     this._produtoService.getProdutosFamilia().subscribe((res) => {
    //         if (!res.success) {
    //             return;
    //         }
    //         // .pipe(map((l) => (l.success ? l.data : [])))
    //         // this.grupos = res.data;
    //     })
    // }

    private carregarProdutos(): void {
        this._produtoService.getAllComExcluidos().subscribe({
            next: (response) => {
                const data = response.data as any;
                const produtosResponse = (data.produtos as ProdutoResponse[]).sort((a, b) =>
                    a.nome.localeCompare(b.nome)
                );


                if (response.success) {
                    this._listaProduto = produtosResponse.filter(
                        (l) =>
                            (l.familia).toLowerCase() != "pizza" &&
                            (l.familia).toLowerCase() != "lasanha"
                    );
                    this.listapordutosPizzaLasanha = produtosResponse.filter(
                        (l) =>
                            (l.familia).toLowerCase() == "pizza" ||
                            (l.familia).toLowerCase() == "lasanha"
                    );

                    this.filtrarProdutosOnInput("");
                } else {
                    console.error("Falha ao carregar produtos: ", response.message);
                }

                this.carregarIngredientes();
                this.carregarAdicionais();
            },
            error: (error) => {
                console.error("Erro ao carregar produtos: ", error);
            },
        });
    }

    public carregarIngredientes() {
        this._produtoService.getIngredientes().subscribe((res) => {
            if (res.success) {
                let listaIngredientesViewModel: IngredienteProdutoViewModel[] = [];

                res.data.forEach((ingrediente) => {
                    const ingredienteEncontrado = this._listaProduto.find((produto) => produto.codigo === ingrediente.codigoProduto);

                    if (ingredienteEncontrado) {
                        const ingredienteViewModel = new IngredienteProdutoViewModel();
                        ingredienteViewModel.nome = ingredienteEncontrado.nome;
                        ingredienteViewModel.codigo = ingredienteEncontrado.codigo;

                        listaIngredientesViewModel.push(ingredienteViewModel);
                        this.listaIngredinetesMap.set(ingredienteViewModel.codigo, ingredienteViewModel);
                    }
                });

                this.listaIngredientes = listaIngredientesViewModel;
            }
        });
    }

    private carregarAdicionais() {
        this._produtoService.getAdicionais().subscribe((res) => {
            if (res.success) {
                let listaAdicionaisViewModel: AdicionalProdutoViewModel[] = [];

                res.data.forEach((adicional) => {
                    const adicionalEncontrado = this._listaProduto.find((produto) => produto.codigo === adicional.codigoProduto);

                    if (adicionalEncontrado) {
                        const adicionalViewModel = new AdicionalProdutoViewModel();

                        adicionalViewModel.nome = adicionalEncontrado.nome;
                        adicionalViewModel.codigo = adicionalEncontrado.codigo;
                        adicionalViewModel.precoAdicional = adicionalEncontrado.venda;

                        listaAdicionaisViewModel.push(adicionalViewModel);
                        this.listaAdicionaisMap.set(adicionalViewModel.codigo, adicionalViewModel);
                    }
                });

                this.listaAdicionais = listaAdicionaisViewModel;
            }
        });
    }

    get produtos(): ProdutoResponse[] {
        return this._listaProduto;
    }

    verificarProdutoExistente(): void {
        const codigoBarras =
            this.cadastroProdutoForm.get("codigoBarrasCtrl")?.value;

        if (codigoBarras) {
            const produtoExistente = this._listaProduto.find(l => l.codBarra == codigoBarras);

            if (produtoExistente) {
                this.produtoAtual = produtoExistente;
                this.preencherFormularioComProduto(produtoExistente);
                this.emEdicao = true;
                this.codigoNaoEncontrado = false;
            } else {
                this.produtoAtual = null;
                this.emEdicao = false;
                this.codigoNaoEncontrado = true;
                this.cadastroProdutoForm.reset();
                this.cadastroProdutoForm.patchValue({
                    codigoBarrasCtrl: codigoBarras,
                });
            }
        } else {
            this.codigoNaoEncontrado = false;
        }
    }

    selecionarProduto(produto: ProdutoResponse) {
        this.produtoAtual = produto;
    }

    preencherFormulario(produto: ProdutoResponse): void {
        this.cadastroProdutoForm.patchValue({
            codigoBarrasCtrl: produto.codBarra,
            nomeCtrl: produto.nome,
            valorVendaCtrl: produto.venda,
            grupoIdCtrl: produto.codFamilia,
            subGrupoIdCtrl: produto.codCategoria
        });
    }

    preencherFormularioComProduto(produto: ProdutoResponse) {
        if (!produto) {
            return;
        }

        this.cadastroProdutoForm.patchValue({
            codigoBarrasCtrl: produto.codBarra,
            nomeCtrl: produto.nome,
            valorVendaCtrl: produto.venda,
            grupoIdCtrl: produto.codFamilia,
            subGrupoIdCtrl: produto.codCategoria,
        });
    }

    @HostListener("window:keyup.arrowup", ["$event"])
    navegarParaCima(event: Event) {
        event.preventDefault();
        const indexAtual = this.produtosFiltrados.indexOf(this.produtoAtual);
        if (indexAtual > 0) {
            //desabilitado por kel, não está funcionando corretamente
            //  this.selecionarProduto(this.produtosFiltrados[indexAtual - 1]);
        }
    }

    @HostListener("window:keyup.arrowdown", ["$event"])
    navegarParaBaixo(event: Event) {
        event.preventDefault();
        const indexAtual = this.produtosFiltrados.indexOf(this.produtoAtual);
        if (indexAtual < this.produtosFiltrados.length - 1) {
            //desabilitado por kel, não está funcionando corretamente
            //this.selecionarProduto(this.produtosFiltrados[indexAtual + 1]);
        }
    }

    private validarAdiconal(adiconal: AdicionalProdutoRequest): string[] {
        const erros: string[] = [];

        if (adiconal.nome.length <= 0) {
            erros.push("Nome é obrigatório");
        }

        if (!this.desabilitarPrecoAdicional && adiconal.precoAdicional <= 0) {
            erros.push("Preço deve ser maior que zero");
        }

        return erros;
    }

    private validarNovoProduto(produto: ProdutoRequest): string[] {
        const grupoEncontrado = this.grupos.find((g) => g.codigo == produto.codFamilia);
        const subGrupoEncontrado = this.subGrupos.find((g) => g.codigo == produto.codCategoria);

        const erros: string[] = [];

        if (!produto.nome || produto.nome.trim().length === 0) {
            erros.push("Nome é obrigatório");
        }

        if (produto.valorVenda <= 0) {
            erros.push("Valor de venda deve ser maior que zero");
        }

        if (produto.codFamilia <= 0 || !grupoEncontrado) {
            erros.push("Grupo inválido");
        }

        if (produto.codCategoria <= 0 || !subGrupoEncontrado) {
            erros.push("SubGrupo inválido");
        }

        return erros;
    }
}

export class CadastroGeralProdutoRequest {
    public codigoBarras: string;
    public aplicacao: string;
    public disponivelEm: string[];
    public estoque: number;
    public grupoId: number;
    public imagem: string | ArrayBuffer;
    public nome: string;
    public subGrupoId: number;
    public valorVenda: number;
}
